/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyEmployeeInviteCreateDto
 */
export interface CompanyEmployeeInviteCreateDto {
  /**
   *
   * @type {string}
   * @memberof CompanyEmployeeInviteCreateDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CompanyEmployeeInviteCreateDto
   */
  companyEmployeeRoleId: string;
}

export function CompanyEmployeeInviteCreateDtoFromJSON(json: any): CompanyEmployeeInviteCreateDto {
  return CompanyEmployeeInviteCreateDtoFromJSONTyped(json, false);
}

export function CompanyEmployeeInviteCreateDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyEmployeeInviteCreateDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json["email"],
    companyEmployeeRoleId: json["companyEmployeeRoleId"],
  };
}

export function CompanyEmployeeInviteCreateDtoToJSON(value?: CompanyEmployeeInviteCreateDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
    companyEmployeeRoleId: value.companyEmployeeRoleId,
  };
}
